const stats = [
  { number: '500+', label: 'Clients Served', icon: 'ri-user-star-line' },
  { number: '1000+', label: 'Successful Projects', icon: 'ri-trophy-line' },
  { number: '50+', label: 'Industry Awards', icon: 'ri-award-line' },
  { number: '98%', label: 'Client Satisfaction', icon: 'ri-heart-line' }
];

export function Stats() {
  return (
    <section className="py-24 bg-gradient-to-r from-purple-600 to-pink-600">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center mx-auto mb-4">
                <i className={`${stat.icon} text-white text-3xl`}></i>
              </div>
              <div className="text-4xl md:text-5xl font-bold text-white mb-2">{stat.number}</div>
              <div className="text-lg text-white/90">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
